"use client";

import { useConvexAuth, useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import {
  defaultShipments,
  useShipmentPlan,
  type ShipmentProduct,
} from "./use-shipment-plan";
import type { DeliveryWindow } from "@/lib/checkout/delivery-window";

export function useListingShipmentSeed(
  product: ShipmentProduct,
  window: DeliveryWindow,
  location: {
    line1?: string;
    line2?: string;
    city: string;
    state: string;
    zip: string;
  } | null,
  hasDockOnSite = true,
) {
  const { isAuthenticated } = useConvexAuth();
  const current = useQuery(
    api.users.queries.current,
    isAuthenticated ? {} : "skip",
  );
  const plan = useShipmentPlan([product], current?.user?._id ?? null);
  return ({ replace = false }: { replace?: boolean } = {}) =>
    (replace ? plan.update : plan.initialize)(
      product.productId,
      defaultShipments(product).map((draft) => ({
        ...draft,
        line1: [location?.line1, location?.line2].filter(Boolean).join(", "),
        city: location?.city ?? "",
        state: location?.state ?? "",
        postalCode: location?.zip ?? "",
        deliveryDate: window.start,
        deliveryWindowEnd: window.end,
        hasDockOnSite,
      })),
    );
}
